/* /assets/bbb-accordion.js — smooth open/close for <details class="bbb-accordion">
   Animates element height on both expand and collapse (native <details> can't).
   Based on the web.dev "animating the details element" pattern. Global. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 320;
  var EASING = 'cubic-bezier(.22,.61,.36,1)';

  function Accordion(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector(':scope > :not(summary)');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    if (!this.summary || !this.content) return;
    var self = this;
    this.summary.addEventListener('click', function (e) { self.onClick(e); });
  }

  Accordion.prototype.onClick = function (e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) this.open();
    else if (this.isExpanding || this.el.open) this.shrink();
  };

  Accordion.prototype.shrink = function () {
    var self = this;
    this.isClosing = true;
    var start = this.el.offsetHeight;
    var end = this.summary.offsetHeight;
    if (this.animation) this.animation.cancel();
    this.animation = this.el.animate({ height: [start + 'px', end + 'px'] }, { duration: DURATION, easing: EASING });
    this.animation.onfinish = function () { self.onFinish(false); };
    this.animation.oncancel = function () { self.isClosing = false; };
  };

  Accordion.prototype.open = function () {
    var self = this;
    this.el.style.height = this.el.offsetHeight + 'px';
    this.el.open = true;
    window.requestAnimationFrame(function () { self.expand(); });
  };

  Accordion.prototype.expand = function () {
    var self = this;
    this.isExpanding = true;
    var start = this.el.offsetHeight;
    var end = this.summary.offsetHeight + this.content.offsetHeight;
    if (this.animation) this.animation.cancel();
    this.animation = this.el.animate({ height: [start + 'px', end + 'px'] }, { duration: DURATION, easing: EASING });
    this.animation.onfinish = function () { self.onFinish(true); };
    this.animation.oncancel = function () { self.isExpanding = false; };
  };

  Accordion.prototype.onFinish = function (open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = '';
    this.el.style.overflow = '';
  };

  function init(root) {
    (root || document).querySelectorAll('details.bbb-accordion').forEach(function (el) {
      if (el.dataset.accInit) return;
      el.dataset.accInit = '1';
      new Accordion(el);
    });
  }

  if (reduce) return; // let native toggle handle it, no animation
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
